export default __webpack_public_path__ + "static/heater_b.9252d02ed036d4974457589fdd4966a3.svg";